import { render, staticRenderFns } from "./ActiveNotices.vue?vue&type=template&id=75f454a9&"
import script from "./ActiveNotices.vue?vue&type=script&lang=js&"
export * from "./ActiveNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports